import { FormInstance } from "antd/es/form";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Footer_ScreenContext } from "../footer/footer-context";

declare let window: any;

export interface IReportsFirstPage_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IReportsFirstPage_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  Connect: any;
  Connect_dummy: any;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
}

export class ReportsFirstPage_ScreenBase extends React.PureComponent<
  IReportsFirstPage_ScreenProps,
  any
> {
  static contextType = Footer_ScreenContext;
  declare context: React.ContextType<typeof Footer_ScreenContext>;

  ml = [
    {
      Id: "782add75-a2c8-e698-bccf-af29bb1e9b35",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [
        {
          Id: 488379,
          PropertyName: "value",
          Value: "Raporlar",
          TagName: "Label6_value",
        },
        {
          Id: 720436,
          PropertyName: "value",
          Value: "Sipariş Raporu",
          TagName: "Label3_value",
        },
        {
          Id: 14258,
          PropertyName: "value",
          Value: "Sevk Raporu",
          TagName: "Label8_value",
        },
        {
          Id: 605462,
          PropertyName: "value",
          Value: "Bekleyen Sipariş Raporu",
          TagName: "Label9_value",
        },
      ],
    },
    {
      Id: "c2176777-61f9-4e18-a818-fb50309cde20",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 488379,
          PropertyName: "value",
          Value: "Reports",
          TagName: "Label6_value",
        },
        {
          Id: 720436,
          PropertyName: "value",
          Value: "Order Report",
          TagName: "Label3_value",
        },
        {
          Id: 14258,
          PropertyName: "value",
          Value: "Dispatch Report",
          TagName: "Label8_value",
        },
        {
          Id: 605462,
          PropertyName: "value",
          Value: "Pending Order Report",
          TagName: "Label9_value",
        },
      ],
    },
    {
      Id: "6029dd56-160a-4c9d-9704-1e76ad2479c8",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 488379, PropertyName: "value", Value: "Raporlar" },
        { Id: 720436, PropertyName: "value", Value: "Sipariş Raporu" },
        { Id: 14258, PropertyName: "value", Value: "Sevk Raporu" },
        { Id: 605462, PropertyName: "value", Value: "Bekleyen Sipariş Raporu" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      Connect: "",
      NAVIGATE: "",
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "reportsfirstpage",
        "footer_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.ReportsFirstPagePageInit();
    } else if (
      !this.context?.callCallbackFunction ||
      this.context?.isMasterPageInitLoaded
    ) {
      this._prevMasterPageInitLoaded =
        this.context?.isMasterPageInitLoaded ?? false;
      await this.ReportsFirstPagePageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "reportsfirstpage",
      "footer_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = ["B2BAdmin"];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "reportsfirstpage",
      "footer_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.ReportsFirstPagePageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.ReportsFirstPagePageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  ReportsFirstPagePageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {};

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ReportsFirstPage/ReportsFirstPagePageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  ReportsFirstPageComponent_380536_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ReportsFirstPageComponent_422204_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/reportsadminsales") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "ReportsFirstPage",
      "ReportsAdminSales",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ReportsFirstPageComponent_26386_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/reportsadminrefferal") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "ReportsFirstPage",
      "ReportsAdminRefferal",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ReportsFirstPageComponent_852863_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/reportsadminrefferalpending") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "ReportsFirstPage",
      "ReportsAdminRefferalPending",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [, ,] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.ReportsFirstPagePageInit();
    }
  }
}
